import { render } from "./CompanyLicenseDocumentField.vue?vue&type=template&id=7d1a83a4"
import script from "./CompanyLicenseDocumentField.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLicenseDocumentField.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Company/CompanyLicenseDocumentField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d1a83a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d1a83a4', __exports__)) {
    api.reload('7d1a83a4', __exports__)
  }
  
  module.hot.accept("./CompanyLicenseDocumentField.vue?vue&type=template&id=7d1a83a4", () => {
    api.rerender('7d1a83a4', render)
  })

}


export default __exports__